<template>
  <div class="CollegeOptometry">
    <div class="page_img">
      <img src="@/assets/img/vision_top.jpg" alt="">
    </div>
    <div class="page_content content flex_row">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="page_summary font_shadow">人才培养体系智能化</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/vision_main.png" alt="">
      <div class="main_explain care_explain">VISUMALL定制了专业全面的眼视光教学资料，图片及视频科普眼视光知识，不断的通过平台和临床教授学习互动，积累自己的眼视光资历</div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column sys_title">
        <div class="sys_summary">手机端视光学院</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="sys_main flex_row">
        <img src="@/assets/img/vision_content1.png" alt="">
      </div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column sys_title">
        <div class="sys_summary">IPAD、PC端视光学院</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="sys_main flex_row">
        <img src="@/assets/img/vision_content2.png" alt="">
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'CollegeOptometry',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
    }
  },
  created() {
  },
}
</script>

<style scoped lang="scss">
.CollegeOptometry {
  .content {
    margin: 0.4rem 0 1.5rem;
  }
  .main {
    img {
      width: 50%;
    }
    .care_explain {
      margin: 1rem 0 1rem;
      width: 65%;
      padding: 0.125rem 0.1125rem;
      font-size: 0.19rem;
      font-weight: 500;
    }
  }
  .system {
    margin-bottom: 0.8rem;
    .sys_title {
      .sys_summary {
        font-weight: bold;
        text-align: center;
        font-size: 0.3rem;
      }
    }
    .sys_main {
      margin-top: 0.8rem;
      img {
        width: 55%;
      }
    }
  }
  .container {
    .container_title {
      margin-bottom: 0.35rem;
      font-weight: 500;
      font-size: 0.25rem;
      color: #005AFF;
    }
    .container_content {
      margin-bottom: 1.3rem;
      flex-wrap: wrap;
      .container_item {
        width: 20%;
        flex-direction: column;
        margin-bottom: 0.55rem;
        img {
          width: 80%;
        }
        span {
          margin-top: 0.1rem;
          font-size: 0.22rem;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
